module.exports = __webpack_public_path__ + "files/997b46fa0fb15bd51e49aaf4675fd2f2.png";